<template>
  <div>
    <div>
      <span class="xbed-sub-title">清洁项目管理</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>麗家会</BreadcrumbItem>
        <BreadcrumbItem>清洁流程管理</BreadcrumbItem>
      </Breadcrumb>
    </div>

    <Tabs class="tabs" style="width:1660px;">
      <TabPane label="清洁步骤项目列表" name="stepItemList" ref="stepItemList">
        <Form @submit.native.prevent="preventSubmit" :model="stepItemList.form" inline>
          <FormItem prop="keyword" label="查询：" :label-width="84">
            <Input type="text" v-model="stepItemList.queryParams.search" @on-change="querySetItemWithKeyword()"></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="toggleStepModal(true)">新增清洁步骤项目</Button>
          </FormItem>
        </Form>
        

        <combo-table :query="stepQuery" :columns="stepItemList.columns" :queryParams="stepItemList.queryParams" ref="stepItemListTable" style="width:850px;"></combo-table>
      </TabPane>

      <TabPane label="物品核查项目列表" name="checkItemList" class="add-distance" ref="checkItemList">
        <Form :model="checkItemList.form" inline>
          <FormItem>
            <Button type="primary" @click="toggleCheckModal(true)">新增核查项目</Button>
          </FormItem>
        </Form>
        <combo-table :query="itemQuery" :columns="checkItemList.columns" :queryParams="checkItemList.queryParams" ref="checkItemListTable"></combo-table>
        
        
      </TabPane>
    </Tabs>

    <!-- Modal 内容 -->
    <Modal v-model="editStepItemModal.display" :title="editStepItemModal.title" :loading="true" @on-ok="preUpdateStepItem">
      <Form @submit.native.prevent="preventSubmit" :model="editStepItemModal" :label-width="84">
        <FormItem label="项目编号：" v-if="editStepItemModal.data.id">
          <span>{{editStepItemModal.data.id}}</span>
        </FormItem>
        <FormItem prop="name" label="项目名称：">
          <Input type="text" :maxlength="255" v-model="editStepItemModal.data.name"></Input>
        </FormItem>
        <FormItem label="描述：">
          <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" v-model="editStepItemModal.data.description"></Input>
        </FormItem>
      </Form>
    </Modal>

    <Modal v-model="editCheckItemModal.display" :title="editCheckItemModal.title" :width="1200" :loading="true" ref="editCheckItemModal" @on-ok="preEditCheckItem">
      <div class="edit-checkitem-modal">
        <div class="item-info">
         <Form :model="editCheckItemModal.item" ref="editCheckItemModalItem" :rules="editCheckItemModal.item.rules" :label-width="84">
           <FormItem v-if="editCheckItemModal.item.id" label="项目编号" prop="id">
              <Input :value="editCheckItemModal.item.id" disabled></Input>
            </FormItem>
            <FormItem label="项目名称" prop="name">
              <Input :maxlength="20" v-model="editCheckItemModal.item.name"></Input>
            </FormItem>

            <FormItem label="项目图片" prop="pic">
              <img v-show="editCheckItemModal.item.pic" :src="editCheckItemModal.item.pic" alt="" style="width:100%">
              <Upload v-show="!editCheckItemModal.item.pic" action="//upload.qiniup.com" name="file" :format="['jpg']" :max-size="5242" :data="editCheckItemModal.item.uploadData" :before-upload="beforeUpload" :on-success="uploadSuccess" :on-format-error="imgFormatError" :show-upload-list="false">
                <Button type="primary" icon="ios-cloud-upload-outline">{{!editCheckItemModal.item.pic? "添加图片" : "删除图片"}}</Button>
              </Upload>
              <Button v-show="editCheckItemModal.item.pic" type="error" @click="delItemPic">删除图片</Button>
            </FormItem>

            <FormItem label="核查类型" prop="type">
              <Select v-model="editCheckItemModal.item.type" transfer placeholder="请选择">
                <Option :value="1">关联物品</Option>
                <Option :value="2">无物品</Option>
              </Select>
            </FormItem>

            <FormItem label="核查时间" prop="checkTime">
              <InputNumber v-model="editCheckItemModal.item.checkTime" :step="1" :precision="0" :min="0" :max="1800"></InputNumber>
              <span>s</span>
            </FormItem>

            <FormItem v-if="editCheckItemModal.item.type === 1" label="核查物品" prop="goods">
              <div class="check-step" v-for="(goods, key, index) of editCheckItemModal.item.goods" :key="key">
                <span>{{`${index+1}、`}}</span>
                <span>{{goods}}</span>
                <span class="remove-step" @click="removeGoods(key)"><Icon type="minus-round"></Icon></span>
              </div>
            </FormItem>

            <FormItem v-else-if="editCheckItemModal.item.type === 2" label="步骤标准" prop="detail">
              <div class="check-step" v-for="(step, index) in editCheckItemModal.item.detail" :key="index">
                <span>{{`${index+1}、`}}</span>
                <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" :maxlength="200" v-model="step.detail"></Input>
                <span v-show="editCheckItemModal.item.detail.length > 1" class="remove-step" @click="removeStep(index)"><Icon type="minus-round"></Icon></span>
              </div>
              <div class="add-step" @click="addStep"><Icon type="plus-round"></Icon></div>
            </FormItem>

          </Form>
        </div>

        <!-- item.type 1关联物品,2无物品 -->
        <!-- 如果选择有物品核查，弹出选择框 -->
        <div v-show="editCheckItemModal.item.type===1" class="choice-goods">
          <label class="item-label">选择物品</label>
          <Form :label-width="84" inline>
            <FormItem label="物品名称">
              <Input :maxlength="100" v-model="editCheckItemModal.goods.goodsName"></Input>
            </FormItem>
            <FormItem label="类别">
              <Cascader v-model="editCheckItemModal.goods.selectedGoodsType" :data="editCheckItemModal.goods.goodsTypeList" :load-data="loadGoodsTypeData" placeholder="全部"></Cascader>
            </FormItem>
            <FormItem label="是否标配">
              <Select v-model="editCheckItemModal.goods.config" placeholder="请选择" transfer filterable clearable>
                <Option value="S00">全部</Option>
                <Option :value="1">标配</Option>
                <Option :value="0">选配</Option>
              </Select>
            </FormItem>
            <Button type="primary" @click="queryGoodsListWithKeyword">查询</Button>
          </Form>
          <Table stripe :loading="editCheckItemModal.loading" ref="editCheckItemModalTable" :columns="editCheckItemModal.goods.columns" :data="editCheckItemModal.goods.displayGoodsList" size="small" width="750"></Table>
          <div style="float: left;margin: 10px;overflow: hidden">
            <Page show-sizer placement="top" :total="editCheckItemModal.goods.count" :current="editCheckItemModal.goods.page" :page-size="editCheckItemModal.goods.pageSize" @on-page-size-change="changeModalPageSize" @on-change="changeModalPage"></Page>
          </div>
        </div>
      </div>
    </Modal>

  </div>
</template>

<script>
import ComboTable from '../../components/combo-table'
import Utils from "../../utils";
import API from "../../api";
import {STORE_KEY} from "../../constants"

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  components: {
    'combo-table': ComboTable
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });

    this.initGoodsListAndType()
  },
  data() {

    const validateModalItem = {
      name: (rule, value, callback) => {
        if (this.editCheckItemModal.item.name.length === 0) {

          callback(new Error('项目名称不能为空'))
        } else if (this.editCheckItemModal.item.name.length > 20) {

          callback(new Error('项目名称不能不能超过20字'))
        } else {
          callback();
        }
      },
      checkTime: (rule, value, callback) => {
        if (this.editCheckItemModal.item.checkTime==="") {
          callback(new Error('核查时间不能为空'))
        } else {
          callback();
        }
      },
      goods: (rule, value, callback) => {
        if (Object.keys(this.editCheckItemModal.item.goods).length === 0) {
          callback(new Error('核查物品不能为空'))
        } else {
          callback();
        }
      },
      detail: (rule, value, callback) => {
        if (this.editCheckItemModal.item.detail[0].detail.length === 0) {
          callback(new Error('请填写步骤标准'))
        } else {
          callback();
        }
      },
      type: (rule, value, callback) => {
        if (!this.editCheckItemModal.item.type) {
          callback(new Error('请选择核查类型'))
        } else {
          callback();
        }
      },
    }

    return {
      currTabName: "stepItemList",
      // 清洁步骤项目列表
      stepItemList: {
        loading: false,
        form: {
          keyword: ""
        },
        columns: [
          {
            title: "项目编号",
            key: "id",
            align: "center",
            width: 150
          },
          {
            title: "项目",
            key: "name",
            align: "center",
            width: 200
          },
          {
            title: "描述",
            key: "description",
            align: "center",
            width: 300
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.toggleStepModal(
                          true,
                          params.row,
                        );
                      }
                    }
                  },
                  "修改"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        if (!this.checkHasPermission('oms_xbclean_xbCleanObject_del')) {
                          return;
                        }

                        this.$Modal.confirm({
                          title: "提示",
                          content: `确定删除${params.row.id} - ${params.row.name}吗？\n一经确定将无法修改`,
                          okText: "确定删除",
                          cancelText: "取消",
                          onOk: async () => {
                            const {id} = params.row
                            const {token,env} = this
                            const resp = (await API.omsAPI[env].cleaner.cleanStepDel(id,token)).data

                            if(resp.retCode){
                              // 失败
                              this.$Notice.error({
                                title: "删除失败",
                                desc: resp.msg
                              });
                            }else{
                              this.$Notice.success({
                                title: "删除成功",
                              });

                              this.$refs.stepItemListTable.reload()
                            }
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        page: 1,
        pageSize: 10,
        count: 0,
        queryParams:{
          search: ''
        }
      },
      // 物品核查项目列表
      checkItemList: {
        loading: false,
        form: {},
        columns: [
          {
            title: "项目编号",
            key: "id",
            align: "center",
            width: 150
          },
          {
            title: "项目名称",
            key: "name",
            align: "center",
            width: 200
          },
          {
            title: "核查类型",
            key: "type",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h('div', {}, ['', '关联物品', '无物品'][params.row.type])
            }
          },
          {
            title: "核查明细",
            key: "detail",
            align: "center",
            width: 300,
            render: (h, params) => {

              if (params.row.type === 2) { // 无物品
                let detailArr = params.row.detail ? JSON.parse(params.row.detail) : []
              
                return h("div", detailArr.map((detail, index) => {
                  return h("p", {}, `${index+1}、${detail}`);
                }))
              } else if (params.row.type === 1) { // 关联物品
                let detailArr = params.row.goodsDetail ? JSON.parse(params.row.goodsDetail) : []
              
                return h("div", detailArr.map((detail, index) => {
                  return h("p", {}, `${index+1}、${detail}`);
                }))
              }
            }
          },
          {
            title: "核查时间",
            key: "checkTime",
            align: "center",
            width: 300,
            render: (h, params) => {
              return h('div', {}, `${params.row.checkTime / 1000}s`)
            }
          },
          {
            title: "核查图片",
            key: "pic",
            align: "center",
            width: 300,
            render: (h, params) => {
              if (params.row.pic) {
                return h("img", {
                  attrs: {
                    src: params.row.pic
                  },
                  style: {
                    width: "300px",
                    height: "200px"
                  }
                });
              } else {
                return h();
              }
            }
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.initCheckModal(params.row);
                      }
                    }
                  },
                  "设置"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        if (!this.checkHasPermission('oms_xbclean_xbCheckObject_del')) {
                          return;
                        }

                        this.$Modal.confirm({
                          title: "提示",
                          content: `项目删除后不可恢复，并将从清洁单类型中删除\n确认删除？`,
                          okText: "确定删除",
                          cancelText: "取消",
                          onOk: async () => {
                            const {id} = params.row
                            const {token,env} = this

                            const resp = (await API.omsAPI[env].cleaner.cleanCheckDel(id,token)).data
                            if(resp.retCode){
                              // 失败
                              this.$Notice.error({
                                title: "删除失败",
                                desc: resp.msg
                              });
                            }else{
                              this.$Notice.success({
                                title: "删除成功",
                              });

                              this.$refs.checkItemListTable.reload()
                            }
                          }
                        });
                        
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        page: 1,
        pageSize: 10,
        count: 0,
        queryParams:{}
      },
      editStepItemModal: {
        display: false,
        title: "新增清洁步骤项目",
        data: {
          name: "",
          description: ""
        }
      },
      editCheckItemModal: {
        display: false,
        title: "新增核查项目",
        // 编辑的核查项目
        item:{
          id: "",
          name: "",
          pic: "",
          type: 1,
          checkTime: 30,
          goods: {},
          detail: [],
          uploadData: {
            name: "",
            form: {}
          },
          rules: {
            name: [
              { required: true, validator: validateModalItem.name, trigger: 'blur' }
            ],
            checkTime: [
              { required: true, validator: validateModalItem.checkTime, trigger: 'blur' }
            ],
            goods: [
              { required: true, validator: validateModalItem.goods }
            ],
            detail: [
              { required: true, validator: validateModalItem.detail }
            ],
            type: [
              { required: true, validator: validateModalItem.type }
            ],
          }
        },
        // 物品选择
        goods:{
          loading: false,
          columns: [{
            title: "操作",
            fixed: 'left',
            width: 80,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: params.row.isChecked ? "error" : "primary",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.selectedChangeWithRow(params.row);
                      }
                    }
                  },
                  params.row.isChecked ? "移除" : "添加"
                )
              ]);
            }
          },
          {
            title: "物品id",
            key: "goodsId",
            align: "center",
            width: 80
          },
          {
            title: "物品名称",
            key: "goodsName",
            align: "center",
            width: 120
          },
          {
            title: "一级类别",
            key: "catalogName",
            align: "center",
            width: 120
          },
          {
            title: "二级类别",
            key: "secondaryCatalogName",
            align: "center",
            width: 80
          },
          {
            title: "型号/品牌",
            key: "goodsModel",
            align: "center",
            width: 80
          },
          {
            title: "规格",
            key: "goodsDesc",
            align: "center",
            width: 100
          },
          {
            title: "是否标配",
            align: "center",
            width: 100,
            render:(h,params)=>{
              const isStandard = params.row.isStandard ? "是" : "否"
              return h('div', {}, isStandard);
            }
          },
          {
            title: "核查类型",
            align: "center",
            width: 120,
            render:(h,params)=>{
              return h('div', {}, ['', '数量标准', '步骤标准', '数量+步骤'][params.row.checkType]);
            }
          }],
          count: 0,
          page: 1,
          pageSize: 10,
          goodsName: "",
          config: "S00",
          // 全部的物品列表
          goodsList:[],
          // 筛选后的物品列表
          filterGoodsList: [],
          // 展示物品列表
          displayGoodsList:[],
          // 物品类型
          goodsTypeList:[],
          // 选择的物品类型
          selectedGoodsType:[],
        },
        
      },
      // 物品类型
    };
  },
  methods: {
    // 清洁步骤项目列表
    stepQuery(params) {
      if (!this.checkHasPermission('oms_xbclean_xbCleanObject_list')) {
        return '';
      }

      return API.omsAPI[this.env].cleaner.cleanStepList(params,this.token)
    },
    querySetItemWithKeyword() {
      this.stepItemList.queryParams.search = this.stepItemList.queryParams.search.trim();

      this.$nextTick(() => {
        this.$refs.stepItemListTable.reload();
      })
    },
    // 物品核查项目列表
    itemQuery(params) {
      return API.omsAPI[this.env].cleaner.cleanCheckList(params,this.token)
    },

    // 切换 清洁步骤项目Modal
    toggleStepModal(
      display,
      modalData = { name: "", description: "" }
    ) {
      this.editStepItemModal.display = display
      this.editStepItemModal.data = Object.assign({},modalData);
    },
    // 切换 核查项目Modal
    toggleCheckModal(display, payload={}){
      this.editCheckItemModal.item = Object.assign(this.editCheckItemModal.item, {
        id: '',
        name: '',
        type: '',
        checkTime: 30,
        detail: [{ detail: '' }],
        goods: {},
        pic: ''
      }, payload);
      if (this.editCheckItemModal.item.id) {
        this.editCheckItemModal.title = '编辑核查项目';
      } else {
        this.editCheckItemModal.title = '新增核查项目';
      }

      // 重置选择物品列表
      this.editCheckItemModal.goods = Object.assign(this.editCheckItemModal.goods, {
        count: this.editCheckItemModal.goods.goodsList.length,
        filterGoodsList: this.editCheckItemModal.goods.goodsList,
        goodsName: '',
        config: 'S00'
      })
      this.displayDataInCurrPage();

      this.editCheckItemModal.display = display
    },
    // 新增清洁步骤项目
    async preUpdateStepItem() {
      const {id,name,description} = this.editStepItemModal.data
      const {username,token,env} = this

      try {
        let resp = undefined
        if(!id){
          resp = (await API.omsAPI[env].cleaner.cleanStepAdd({name,description,createName:username},token)).data
        }else{
          if (!this.checkHasPermission('oms_xbclean_xbCleanObject_edit')) {
            return;
          }

          resp = (await API.omsAPI[env].cleaner.cleanStepEdit({id,name,description,updateName:username,used:1},token)).data
        }

        if(resp.retCode){
          // 失败
          this.$Notice.error({
            title: "操作失败",
            desc: resp.msg
          });
        }else{
          this.$Notice.success({
            title: "操作成功",
          });
        }
      } catch (error) {
        console.error(error)
      } finally{
        this.toggleStepModal(false)
        this.$refs.stepItemListTable.reload()
      }
    },

    // 初始化物品列表和类别
    async initGoodsListAndType(){
      // 获取物品类别
      const resp = (await API.omsAPI[this.env].cleaner.getSelectiveForCleanerGoodsList({},this.token)).data
      
      if(resp.retCode){
        // 失败
        this.$Notice.error({
          title: "初始化物品类型失败",
          desc: resp.msg
        });
      }else{
    
        for (let index = 0; index < resp.length; index++) {
          let type = resp[index]
          type.value = type.id
          type.label = type.catalogName
          type.children = []
          type.loading = false

        }
          this.editCheckItemModal.goods.goodsTypeList = resp
      }

      const goodsListResp = (await API.omsAPI[this.env].cleaner.getGoodsList(this.token)).data
      
      if(goodsListResp.retCode){
        // 失败
        this.$Notice.error({
          title: "初始化物品列表失败",
          desc: goodsListResp.msg
        });
      }else{
        const goodsList = goodsListResp.content.map(goods => {
          goods.isChecked = false;
          return goods;
        })
        this.editCheckItemModal.goods.goodsList = goodsList
      }
    },

    // 加载二级物品类型选项
    async loadGoodsTypeData(item,callback){
      item.loading = true

      // 获取物品类别
      const resp = (await API.omsAPI[this.env].cleaner.getSelectiveForCleanerGoodsList({parentId:item.id},this.token)).data

      if(resp.retCode){
        // 失败
        this.$Notice.error({
          title: "获取物品类型失败",
          desc: resp.msg
        });
      }else{
        for (let index = 0; index < resp.length; index++) {
            let type = resp[index]
            type.value = type.id
            type.label = type.catalogName
        }
        
        resp.unshift({
          value:'-1',
          label:'全部'
        })
        
        item.children = resp
      }

      item.loading = false
      callback()

    },

    // 初始化物品核查项目
    initCheckModal(currRow) {
      let checkTime = 30;
      if (currRow.checkTime !== '') {
          checkTime = currRow.checkTime / 1000
      }

      let detail = [{detail: ''}];
      if (currRow.detail) {
        detail = JSON.parse(currRow.detail).map(detail => {
          return {
            detail
          }
        });
      }

      let goods = {};
      if (currRow.goodsDetail) {
        const goodsDetailArr = JSON.parse(currRow.goodsDetail);
        goodsDetailArr.map(goodsDetail => {
          const goodsId = +goodsDetail.split('_')[0];
          goods[goodsId] = goodsDetail;
        })
      }

      const payload = {
        id: currRow.id,
        name: currRow.name,
        type: currRow.type,
        checkTime,
        detail,
        goods,
        pic: currRow.pic
      }
      this.toggleCheckModal(true, payload);
    },

    // 新增物品核查项目
    async preEditCheckItem() {
      // 权限校验
      if (!this.editCheckItemModal.item.id && !this.checkHasPermission('oms_xbclean_xbCheckObject_add')) {
        this.$refs.editCheckItemModal.buttonLoading = false;
        return
      } else if (this.editCheckItemModal.item.id && !this.checkHasPermission('oms_xbclean_xbCheckObject_edit')) {
        this.$refs.editCheckItemModal.buttonLoading = false;
        return
      }

      let validResult = false;
      this.$refs.editCheckItemModalItem.validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        this.$refs.editCheckItemModal.buttonLoading = false;
        return;
      }

      let params = {
        checkTime: (+this.editCheckItemModal.item.checkTime) * 1000,
        name: this.editCheckItemModal.item.name,
        type: this.editCheckItemModal.item.type,
        pic: this.editCheckItemModal.item.pic,
        createName: this.username
      }

      if (this.editCheckItemModal.item.type === 2) {

        let validDetail = true; // 验证是否有空步骤
        const detail = this.editCheckItemModal.item.detail.map(item => {
          if (item.detail.trim().length === 0) {
            validDetail = false;
          }
          return item.detail
        });

        if (!validDetail) {
          this.$Notice.error({
            title: "操作失败",
            desc: '步骤标准不能为空'
          });
          this.$refs.editCheckItemModal.buttonLoading = false;
          return;
        }

        params.detail = JSON.stringify(detail);
      } else if (this.editCheckItemModal.item.type === 1) {

        const goodsIds = Object.keys(this.editCheckItemModal.item.goods).map((goods) => {
          return +goods
        })

        params.goodsIds = goodsIds.toString();
      }

      // 编辑传id
      this.editCheckItemModal.item.id && (params.id = this.editCheckItemModal.item.id);

      const apiName = this.editCheckItemModal.item.id ? 'cleanCheckEdit' : 'cleanCheckAdd';

      const resp = (await API.omsAPI[this.env].cleaner[apiName](params, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "操作失败",
          desc: resp.msg
        });
        this.$refs.editCheckItemModal.buttonLoading = false;
        return
      }

      this.$Notice.success({
        title: "操作成功"
      });

      this.$refs.checkItemListTable.reload()

      this.toggleCheckModal(false);
      
    },
    // 前端查询
    queryGoodsListWithKeyword() {
      this.editCheckItemModal.goods.loading = true;
      this.editCheckItemModal.goods.filterGoodsList = this.filterGoodsListWithKeyword();
      this.editCheckItemModal.goods.page = 1;
      this.editCheckItemModal.goods.count = this.editCheckItemModal.goods.filterGoodsList.length;
      this.editCheckItemModal.goods.pageCount = (this.editCheckItemModal.goods.count % this.editCheckItemModal.goods.filterGoodsList.length) == 0 ? (this.editCheckItemModal.goods.count / this.editCheckItemModal.goods.filterGoodsList.length) : (this.editCheckItemModal.goods.count / this.editCheckItemModal.goods.filterGoodsList.length + 1)
      this.displayDataInCurrPage();
      this.editCheckItemModal.goods.loading = false;

      this.$nextTick(() => {
        this.changeRowCheckedProps();
      })
    },
    // 前端过滤
    filterGoodsListWithKeyword() {
      let {goodsName, selectedGoodsType, config} = this.editCheckItemModal.goods;

      // 搜索一级类别，二级类别
      let searchGoodsCatalog = '';
      let searchSecondaryCatalog = '';

      if (selectedGoodsType.length > 0) {
        searchGoodsCatalog = selectedGoodsType[0];
        searchSecondaryCatalog = selectedGoodsType[1] == '-1' ? '' : selectedGoodsType[1];
      }

      return this.editCheckItemModal.goods.goodsList.filter((goods) => {

        // 匹配物品名称
        const queryGoodsNameResult = goods.goodsName.toUpperCase().indexOf(goodsName.toUpperCase()) !== -1;

        // 匹配物品一级类别
        let queryGoodsCatalogResult = true;
        if (searchGoodsCatalog!== '') {
          queryGoodsCatalogResult = goods.goodsCatalog == searchGoodsCatalog;
        }

        // 匹配物品二级类别
        let querySecondaryCatalog = true;
        if (searchSecondaryCatalog!== '') {
          querySecondaryCatalog = goods.secondaryCatalog == searchSecondaryCatalog;
        }

        // 匹配物品是否标配
        let queryConfig = true;
        config = config == 'S00' ? '' : config
        if (config !== '') {
          queryConfig = config == goods.isStandard; 
        } 

        // 匹配是否选中
        let queryNotSelect = false;
        if (!this.editCheckItemModal.item.goods[goods.goodsId]) {
          queryNotSelect = true;
        }

        return queryGoodsNameResult && queryGoodsCatalogResult && querySecondaryCatalog && queryConfig && queryNotSelect;
      });
    },
    // 选择物品table展示数据
    displayDataInCurrPage() {
      const startIndex = (this.editCheckItemModal.goods.page-1) * this.editCheckItemModal.goods.pageSize;
      const endIndex = this.editCheckItemModal.goods.pageSize * this.editCheckItemModal.goods.page;

      // 重置展示数组
      this.editCheckItemModal.goods.displayGoodsList = [];

      let displayGoodsList = [];
      for (let i=startIndex; i<endIndex; i++) {
        if (!this.editCheckItemModal.goods.filterGoodsList[i]) break;
        displayGoodsList.push(this.editCheckItemModal.goods.filterGoodsList[i]);
      }
      this.editCheckItemModal.goods.displayGoodsList = displayGoodsList;
      
      // 更新展示数据的样式
      this.changeRowCheckedProps();
    },
    changeRowCheckedProps() {
      const length = this.editCheckItemModal.goods.goodsList.length;
      
      for (let i = 0; i < length; i++) {
        if (this.editCheckItemModal.item.goods[this.editCheckItemModal.goods.goodsList[i].goodsId]) {
          this.editCheckItemModal.goods.goodsList[i].isChecked = true;
          continue;
        }
        this.editCheckItemModal.goods.goodsList[i].isChecked = false;
      }

      this.$nextTick(() => {
        this.editCheckItemModal.item.goods = Object.assign({}, this.editCheckItemModal.item.goods);
      })
    },
    selectedChangeWithRow(currRow) {
      currRow.isChecked = !currRow.isChecked
      if (currRow.isChecked) {
        const checkType = currRow.checkType === 1 
          ? '数量标准'
          : currRow.checkType === 2
          ? '步骤标准'
          : currRow.checkType === 3
          ? '数量+步骤'
          : ''

        const goods = `${currRow.goodsId}_${currRow.goodsName}_${checkType}`

        this.editCheckItemModal.item.goods[currRow.goodsId] = goods;
      } else {

        delete this.editCheckItemModal.item.goods[currRow.goodsId];
      }

      // 更新数据
      this.editCheckItemModal.goods.filterGoodsList = this.filterGoodsListWithKeyword();

      this.$nextTick(() => {
        this.displayDataInCurrPage();
      })

      // 改变更改后的样式
      // this.changeRowCheckedProps();
    },
    addStep() {
      this.editCheckItemModal.item.detail.push({ detail: '' });
    },
    removeGoods(goodsId) {

      delete this.editCheckItemModal.item.goods[goodsId];

      // 更新数据
      this.editCheckItemModal.goods.filterGoodsList = this.filterGoodsListWithKeyword();

      this.$nextTick(() => {
        this.displayDataInCurrPage();
      })

      // 更新样式
      // this.$nextTick(() => {
      //   this.changeRowCheckedProps();
      // })
    },
    removeStep(delIndex) {
      this.editCheckItemModal.item.detail.splice(delIndex, 1);
    },
    // 删除图片
    delItemPic() {
      this.editCheckItemModal.item.pic = '';
    },
    // 图片上传前
    async beforeUpload(file) {
      console.info(`${file}`)

      const fileMaxSize = 5242880 // 图片最大上传大小

      if (file.size > fileMaxSize) {
        this.$Notice.error({
          title: "添加图片失败",
          desc: '不能选择超过5m的图片'
        });
        return false;
      }

      const token = (await API.omsAPI[this.env].common.getUploadToken(false, this.token)).data;
      this.editCheckItemModal.item.uploadData.token = token;
      this.editCheckItemModal.item.uploadData["x:isPrivate"] = 0;
      this.editCheckItemModal.item.uploadData["x:remark"] = "新增图片";

      return true;
    },
    uploadSuccess(resp) {
      this.editCheckItemModal.item.pic = resp.materialBase.url;
    },
    imgFormatError() {
      this.$Notice.error({
        title: "图片格式必须为jpg"
      });
    },
    changeModalPage(pageIndex) {
      this.editCheckItemModal.goods.page = pageIndex;
      this.displayDataInCurrPage();
    },
    changeModalPageSize(pageSize) {
      this.editCheckItemModal.goods.page = 1;
      this.editCheckItemModal.goods.pageSize = pageSize;
      this.displayDataInCurrPage();
    },
    // 权限校验
    checkHasPermission(name) {
      if(!Utils.hasPermission(name)){
        this.$Notice.error({
          title: Utils.getFromStore(STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS)
        });

        return false;
      }
      return true;
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  margin-top: 20px;
}
.add-distance {
  padding-left: 1px;
}
.edit-checkitem-modal {
  display: flex;
  flex-direction: row;
  justify-content: center;
  .item-info {
    flex: 0 0 400px;
    padding: 0 20px;
  }
  .choice-goods {
    flex: 0 0 750px;
    padding: 0 20px;
    border-left: 1px solid #ccc;
  }
  .item-label {
    display: block;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
    color: #495060;
    padding: 5px 12px 10px 0;
  }
}
.check-step{
  display: flex;
  margin-bottom: 12px;
  .remove-step {
    margin-left: 12px;
    i { 
      padding: 2px 4px;
      color: #ed3f14;
      border: 2px solid #ed3f14;
      border-radius: 8px;
      font-size: 12px;
    }
  }
}
.add-step {
  margin-top: 18px;
  margin-left: 18px;
  i { 
    padding: 4px 8px;
    color: #2d8cf0;
    border: 2px solid #2d8cf0;
    border-radius: 8px;
    font-size: 18px;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/cleaner/item-list.vue